<template>
  <img
    :src="logoUrl"
    :alt="logoAlt"
    :class="logoClass"
    :style="inlineStyle"
  />
</template>

<script>
import siteIdentityApi, {
  loadSiteIdentity,
} from "@/helpers/site-identity/site-identity-api.js";

export default {
  name: "AppBrandLogo",
  props: {
    size: {
      type: String,
      default: "lg",
      validator: (value) => ["sm", "lg"].includes(value),
    },
    url: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      resolvedUrl: null,
      resolvedAlt: null,
    };
  },
  computed: {
    logoUrl() {
      return this.url || this.resolvedUrl || siteIdentityApi.FALLBACK_MAIN_LOGO.url;
    },
    logoAlt() {
      return this.alt || this.resolvedAlt || siteIdentityApi.FALLBACK_MAIN_LOGO.alt;
    },
    inlineStyle() {
      if (this.className) {
        return {};
      }

      if (this.$props.height !== null) {
        return { height: `${this.$props.height}px` };
      }

      return {
        height: `${this.size === "sm" ? 28 : 45}px`,
      };
    },
    logoClass() {
      return ["app-brand-logo", this.className].filter(Boolean).join(" ");
    },
  },
  async mounted() {
    if (!this.url) {
      const identity = await loadSiteIdentity();
      this.resolvedUrl = identity?.main_logo?.url || null;
      this.resolvedAlt = identity?.main_logo?.alt || null;
    }
  },
};
</script>

<style scoped>
.app-brand-logo {
  width: auto;
  object-fit: contain;
}
</style>
